import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcLab = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.6022 2.52725C12.6337 1.49584 14.0328 0.916441 15.4915 0.916527C16.9502 0.916613 18.3492 1.49617 19.3806 2.52771C20.412 3.55925 20.9914 4.95826 20.9913 6.41699C20.9912 7.87572 20.4117 9.27467 19.3801 10.3061L10.3051 19.3811C9.27358 20.4125 7.87456 20.9919 6.41583 20.9918C4.95711 20.9917 3.55816 20.4122 2.52674 19.3806C1.49532 18.3491 0.91593 16.9501 0.916016 15.4913C0.916102 14.0326 1.49566 12.6337 2.5272 11.6023L11.6022 2.52725ZM18.083 9.009L14.1945 12.8984L9.00895 7.71283L12.8984 3.82434C13.2374 3.47757 13.6419 3.2015 14.0883 3.01212C14.5348 2.82273 15.0144 2.7238 15.4993 2.72104C15.9843 2.71829 16.465 2.81176 16.9136 2.99606C17.3621 3.18035 17.7697 3.4518 18.1127 3.7947C18.4556 4.13759 18.7271 4.54511 18.9115 4.99366C19.0959 5.44221 19.1895 5.92288 19.1868 6.40784C19.1841 6.8928 19.0853 7.37242 18.896 7.81891C18.7067 8.2654 18.4307 8.66991 18.084 9.009H18.083Z"
	})
});
export default SvgIcLab;
